<form>
  <div class="label">
    <label>
      <span class="text text_checkbox" translate>blindreading.parameters.wordsCount</span>
    </label>
    <input type="number" gameParameter="wordsCount" />
  </div>
  <div class="label">
    <label>
      <span class="text text_checkbox" translate>blindreading.parameters.wordPerMinute</span>
    </label>
    <input type="number" gameParameter="wordsPerMinute" />
  </div>
  <div class="label">
    <label>
      <span class="text text_checkbox" translate>blindreading.parameters.wordsLength</span>
    </label>
    <input type="number" gameParameter="wordsLength" />
  </div>

  <ms-global-parameters [taskEndSongHidden]="isMenuSettings"></ms-global-parameters>
</form>
